import { createActions } from '@redux-async-module/actions-utils';

import { NAMESPACE, StartPayload, SuccessPayload } from './types';

export const retrieveDraft = createActions<StartPayload, SuccessPayload>(
  NAMESPACE,
  'RETRIEVE_DRAFT',
);
